export default {
  login: "Please login to continue...",
  password_rule: "* Password is case sensitive and must be 6 to 10 characters in length.",
  nickname_rule: "* You can set nickname for display and login (6 to 15 alphabets or digits). Please note that you can set this nickname only once. You cannot modify or cancel it once it’s been set.",
  change_password_succeed: "Change Password Successfully.",
  add_secondary_succeed: "Set Nickname Successfully.",
  succeed: "You have successfully completed the action!",
  failed: "You have failed to complete the action!",
  no_information_available: "No information is available.",
  select_display_language: "Select your preferred default language.",
  select_odds_type: "Select your preferred default odds type display.",
  select_page_type: "Select your preferred page type as default for displaying in both today and early market page.",
  select_show_score_map: "Enable system to automatically show score map while placing bet.",
  select_default_event_sorting: "Select your preferred default events sorting display.",
  select_market_type: "Select your preferred market.",
  select_page_size: "Select your preferred page size.",
  change_sports_menu_order: "Please drag the sports to change the desired order of sports menu.",
  view_outstanding_bets_in_bet_list: "The outstanding bets may take some time to process. Please go to Bet List to view your latest outstanding bets.",
  time_display_in_gmt_plus_8: "The time above is displayed in GMT+8.",
  select_default_stake: "Enable System To Automatically Input Your Customized Stake And Last Bet Stake.",
  bet_empty: "Your bet slip is empty. Please click on odds in the table to make your bet selection.",
  no_event: "No matches or games available now. Please visit other sport events or games or come back later.",
  no_bets: "No Running Bet",
  no_waiting: "No Waiting Bet",
  no_void: "No Void Bet",
  confirmation: "Are you confirm to place this bet?",
  olderversion: "An older version detected, click OK to update or press Ctrl-F5.",
  gmt8: "The time above is displayed in GMT+8.",
  confirm_bet: "Confirm Bet?",
  match_not_started: "Match Not Started",
  odds_changed: "Odds has changed",
  ldiff_changed: "Percent has changed",
  to: "to",
  dnsta: "Do not show this again.",
  login2: "To log in and access our games, you must first register an account. If you already have an account, please continue to log in.",
  no_video: "No video found in %%",
  days: "Days",
  hours: "Hours",
  mins: "Mins",
  secs: "Secs",
  room_full: "This room is full",
  room_joined: "You have joined this room",
  no_room: "No room available. Please select other option and search again or come back later.",
  are_you_sure: "Are you sure to proceed this action?",
  no_matches: "No matches or games available now.",
  pin_code: "e.g. 123456",
  accept_terms: "By ticking, you are confirming that you have read, understood and agree to the terms and conditions above.",
  accept_required: "Please read, understood and agree to the<br />terms and conditions above before proceeding.",
  my_room: "My Room",
  not_winning_prize_in_this_tournament: "Not winning prize in this tournament",
  you_did_not_join_this_room: "You did not join this room",
  room_password_rule: "* PIN code must be 6 digit numbers.",
  jan: "January",
  feb: "February",
  mar: "March",
  apr: "April",
  may: "May",
  jun: "June",
  jul: "July",
  aug: "August",
  sep: "September",
  oct: "October",
  nov: "November",
  dec: "December",
  must_accept_better_odds: "By default, place bet will auto accept better odds. Please refer to the Terms & Conditions for more information.",
  maintenance_notice: "Currently, we are performing system maintenance. Please try again later.",
  deduct_confirm: "This will start the game and your credits will be deducted.<br />Are you sure to continue?",
  no_more_bets: "No more bets.",
  over_max_match: "The matches in this league exceed the maximum number of selectable matches.<br />Please expand the league and select the desired match.",
  button_skip: "Skip tour",
  button_previous: "Previous",
  button_next: "Next",
  button_stop: "Finish",
  button_continue: "Continue",
  tour_content_1: "<h6>Welcome to the WBET tournament</h6><p>We are pleased to announce an exciting new tournament exclusively for our site supporters.</p>",
  tour_content_2: "<h6>Public rooms</h6><p>Members engage in competitive gameplay against each other, usually with an entry fee.</p>",
  tour_content_3: "<h6>Private rooms</h6><p>Members can open rooms to play with friends by utilizing an invited pin for entry.</p>",
  tour_content_4: "<h6>Public free rooms</h6><p>Organized by various organizations during special events exclusively for members, offering free participation.</p>",
  tour_content_5: "<h6>Total player can join & charges</h6><p>Players : Capacity of the room.</p><p>Entry Fee: Base by Rooms offer ( Currency Of the Account Holder).</p>",
  tour_content_6: "<h6>Room details</h6><p>Click here to preview the room statics and join the room.</p>",
  tour_content_7: "<h6>Pools details</h6><p>Total Pool prizes for winner  & Unique room ID to search.</p>",
  tour_content_8: "<h6>Room start details</h6><p>Room status & Last join time display.</p>",
  tour_content_9: "<h6>Private room create</h6><p>To Create private room play and invited friends to join by pin for entry.</p>",
  tour_content_10: "<h6>Points Ranking</h6><p>This feature is to display the points for the player viewing and tracking the result.</p>",
  banner1_h1: "Sports Betting",
  banner1_p: "With a comprehensive selection of over 90 sports and thousands of live matches to bet on, the adrenalin rush never ends.",
  banner2_h1: "Live Casino",
  banner2_p: "Rake in winnings, all while enjoying a rich and immersive casino gaming experience at any of our luxurious suites.",
  banner3_h1: "Slot Games",
  banner3_p: "An extensive selection of games, as far as the eye can see. Get a firsthand taste of it now.",
  banner4_h1: "E-Fighting",
  banner4_p: "Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight!",
  banner5_h1: "Tournament",
  banner5_p: "Get ready for the ultimate display for skills, strategy, and passion as teams from all over the city battle it out in the annual football tournament.",
};
